import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { radius, themeMode, fontWeight, spacing, palette, color } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';

var getSwitchSizeMultiplier = function getSwitchSizeMultiplier(size) {
  switch (size) {
    case "sm":
      return 1;

    case "md":
      return 1.5;

    case "lg":
      return 2.25;

    default:
      return 1.5;
  }
};

var factor = {
  big: 32,
  small: 16,
  tiny: 2
};
var ComponentWrapper = styled(Box).attrs(function () {
  return {
    as: "label"
  };
}).withConfig({
  componentId: "sc-1uhtj7h-0"
})(["position:relative;display:flex;justify-content:center;align-content:center;align-items:center;cursor:pointer;"]);
var InnerSwitch = styled(Box).withConfig({
  componentId: "sc-1uhtj7h-1"
})(["position:relative;width:", ";height:", ";display:flex;justify-content:center;align-content:center;align-items:center;border-radius:", ";background-color:", ";transition:0.2s;&:hover{background-color:", ";transition:0s;}"], function (_ref) {
  var size = _ref.size;
  return factor.big * getSwitchSizeMultiplier(size) + "px";
}, function (_ref2) {
  var size = _ref2.size;
  return factor.small * getSwitchSizeMultiplier(size) + "px";
}, radius("round"), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.700")
}), themeMode({
  light: palette("neutral.400"),
  dark: palette("neutral.700")
}));
var Handle = styled(Box).withConfig({
  componentId: "sc-1uhtj7h-2"
})(["display:block;position:absolute;width:", ";height:", ";transition:0.2s;left:0;top:0;padding:", ";&:before{content:'';display:block;height:100%;width:100%;border-radius:", ";background-color:", ";}"], function (_ref3) {
  var size = _ref3.size;
  return factor.small * getSwitchSizeMultiplier(size) + "px";
}, function (_ref4) {
  var size = _ref4.size;
  return factor.small * getSwitchSizeMultiplier(size) + "px";
}, function (_ref5) {
  var size = _ref5.size;
  return factor.tiny * getSwitchSizeMultiplier(size) + "px";
}, radius("round"), function (_ref6) {
  var isDisabled = _ref6.isDisabled;
  return isDisabled ? themeMode({
    light: palette("neutral.200"),
    dark: palette("neutral.500")
  }) : themeMode({
    light: palette("neutral.0"),
    dark: palette("neutral.0")
  });
});
var OuterSwitch = styled(Box).withConfig({
  componentId: "sc-1uhtj7h-3"
})(["border-radius:", ";input[type='checkbox']:focus ~ &&,input[type='checkbox']:focus-visible ~ &&{box-shadow:", " 0px 0px 0px ", "px;}input[type='checkbox']:focus:not(:focus-visible) ~ &&{box-shadow:none;}input[type='checkbox']:checked ~ &&{& > ", "{background-color:", ";transition:0.2s;&:hover{background-color:", ";transition:0s;}}}input[type='checkbox']:checked ~ &&{& ", "{left:", ";}}"], radius("round"), themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
}), factor.tiny, InnerSwitch, function (_ref7) {
  var isDisabled = _ref7.isDisabled;
  return isDisabled ? themeMode({
    light: palette("neutral.400"),
    dark: palette("neutral.700")
  }) : themeMode({
    light: palette("primary.500"),
    dark: palette("primary.500")
  });
}, function (_ref8) {
  var isDisabled = _ref8.isDisabled;
  return isDisabled ? themeMode({
    light: palette("neutral.400"),
    dark: palette("neutral.700")
  }) : themeMode({
    light: palette("primary.500"),
    dark: palette("primary.500")
  });
}, Handle, function (_ref9) {
  var size = _ref9.size;
  return "calc(100% - " + factor.small * getSwitchSizeMultiplier(size) + "px)";
});
var OffLabel = styled(Box).withConfig({
  componentId: "sc-1uhtj7h-4"
})(["font-weight:", ";margin-right:", ";"], fontWeight("bold"), function (_ref10) {
  var size = _ref10.size;
  return size === "lg" ? spacing("md") : spacing("xs");
});
var OnLabel = styled(Box).withConfig({
  componentId: "sc-1uhtj7h-5"
})(["font-weight:", ";margin-left:", ";"], fontWeight("bold"), function (_ref11) {
  var size = _ref11.size;
  return size === "lg" ? spacing("md") : spacing("xs");
});
var Styled = {
  ComponentWrapper: ComponentWrapper,
  OuterSwitch: OuterSwitch,
  InnerSwitch: InnerSwitch,
  OffLabel: OffLabel,
  OnLabel: OnLabel,
  Handle: Handle
};
export { Styled, getSwitchSizeMultiplier };